export class Coordinates {
    x: number;
    y: number;
    alignCenter: boolean;
}



// WEBPACK FOOTER //
// ./src/app/shared/coordinates.model.ts